(() => {
  'use strict';

  const page = () => ({
    page_type: document.body?.className.match(/template-([a-z-]+)/)?.[1] || '',
    page_path: location.pathname,
    page_title: document.title
  });

  function publish(name, detail = {}) {
    const payload = { event: `ja_${name}`, ...page(), ...detail };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('jartswork:analytics', { detail: payload }));
  }

  // Prevent accidental double-fires from rapid clicks/navigation while leaving
  // deliberate repeat interactions (e.g. save/remove/save) measurable.
  const recent = new Map();
  function publishOnce(key, name, detail = {}, windowMs = 1200) {
    const now = Date.now();
    const last = recent.get(key) || 0;
    if (now - last < windowMs) return;
    recent.set(key, now);
    publish(name, detail);
  }

  window.JAAnalytics = window.JAAnalytics || { publish };

  if (document.body.classList.contains('template-product')) {
    const productRoot = document.querySelector('[data-charles][data-product-title]');
    publish('product_view', {
      product_title: productRoot?.dataset.productTitle || document.querySelector('h1')?.textContent?.trim() || '',
      product_price: productRoot?.dataset.productPrice || '',
      product_available: productRoot?.dataset.productAvailable || ''
    });
  }

  // Shopify Horizon emits this standard event before the request and exposes a
  // promise that resolves after the cart update. Track the conversion only after
  // that promise confirms success, instead of counting both click + submit.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !event.promise) return;

    const quantity = Array.isArray(event.lines)
      ? event.lines.reduce((sum, line) => sum + (Number(line?.quantity) || 0), 0)
      : 0;

    event.promise
      .then((result) => {
        if (result?.detail?.didError || result?.userErrors?.length) return;

        publish('add_to_cart_submit', {
          quantity,
          context: event.context || '',
          cart_quantity: result?.cart?.totalQuantity ?? '',
          currency: result?.cart?.cost?.totalAmount?.currencyCode || '',
          cart_total: result?.cart?.cost?.totalAmount?.amount || ''
        });
      })
      .catch(() => {
        // Failed cart requests are intentionally not counted as conversions.
      });
  });

  document.addEventListener('click', (event) => {
    const el = event.target.closest('a,button,[role="button"]');
    if (!el) return;

    const href = el.matches('a') ? (el.getAttribute('href') || '') : '';
    const text = (el.textContent || '').trim().toLowerCase();

    if (el.matches('[data-charles-launcher]')) {
      publishOnce('charles_open', 'charles_open');
    }

    if (el.matches('[data-ja-save-artwork]')) {
      const wasSaved = el.getAttribute('aria-pressed') === 'true';
      publish('saved_work_toggle', {
        action: wasSaved ? 'remove' : 'save',
        source: 'artwork_control',
        product_id: el.dataset.productId || '',
        product_title: el.dataset.productTitle || ''
      });
    }

    if (el.matches('[data-ja-remove-saved]')) {
      publish('saved_work_toggle', {
        action: 'remove',
        source: 'saved_works_dialog',
        product_id: el.dataset.jaRemoveSaved || ''
      });
    }

    if (el.matches('[data-ja-saved-open]')) {
      publishOnce('saved_works_open', 'saved_works_open');
    }

    if (el.matches('[data-ja-frame-choice]')) {
      publish('frame_choice', { frame_color: el.dataset.frameColor || '' });
    }

    if (el.matches('[data-ja-addon-remove]')) {
      publish('cart_extra_remove', {
        extra: el.closest('[data-ja-cart-addon]')?.dataset.addonType || ''
      });
    }

    const isRoomAction =
      el.matches('[data-ja-room-open]') ||
      (el.matches('a') && href.includes('j-artwork-view-in-room')) ||
      text.includes('view in room');

    if (isRoomAction) {
      publishOnce(`view_in_room:${location.pathname}`, 'view_in_room');
    }

    if (el.matches('button[name="checkout"], [name="checkout"], a[href*="/checkout"]')) {
      publishOnce('checkout_start', 'checkout_start', { source: 'cart' }, 2000);
    }

    const instagramLink = el.matches('a') && (
      Boolean(el.closest('[data-ja-instagram-feed-app]')) ||
      Boolean(el.closest('.ja-instagram-feed__fallback')) ||
      /instagram\.com\/j_artswork/i.test(href)
    );
    if (instagramLink) {
      publish('instagram_click', { href });
    }

    if (href && /commission|schilderij-op-aanvraag/.test(href)) publish('commission_click');
    if (href && /contact/.test(href)) publish('contact_click');
  }, { passive: true });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('[data-charles-form]')) publish('charles_question');
    if (form.closest('.ja-commission-page') || form.classList.contains('ja-commission-form')) {
      publish('commission_form_submit');
    }
    if (form.closest('.ja-contact-page')) publish('contact_form_submit');
  }, true);
})();
